// const myMapFields = (namespace, fields) => {
//   return _.mapValues(fields, path => {
//     return {
//       get () {
//         return _.get(this.$store.state[namespace], path)
//       },
//       set (value) {
//         this.$store.commit(`${namespace}/myUpdateField`, { path, value })
//       }
//     }
//   })
// }

// You can sort ascending as well as descending and chain sort by multiple properties.
// s.sort(by("first", by("last")))     // first ascending, last ascending
// s.sort(by("first", by("last", 0, false)))    // first ascending, last descending
function by (name, minor, isAscending = true) {
  const reverseMutliplier = isAscending ? 1 : -1
  return function (o, p) {
    let a, b
    let result
    if (o && p && typeof o === 'object' && typeof p === 'object') {
      a = o[name]
      b = p[name]
      if (a === b) {
        return typeof minor === 'function' ? minor(o, p) : 0
      }
      if (typeof a === typeof b) {
        result = a < b ? -1 : 1
      } else {
        result = typeof a < typeof b ? -1 : 1
      }
      return result * reverseMutliplier
    }
    return null
  }
}

function parseJwt (token) {
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))

  return JSON.parse(jsonPayload)
}

function sleep (ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

function isIos () {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
}

export { by, parseJwt, sleep, isIos }
